export class CONFIG {
  static APP_TYPE = 'mm';
  static SERVICE_NAME = 'market';
}

export const TRACKER_VIEW_THRESHOLD = 0.5;
